import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { ApiClientError } from '../../resources/shared/api/client';
import { sendErrorReport } from '../utilities/sendErrorReport';

export const QUERY_STALE_TIMES = {
    DEFAULT: 30 * 1000, // 30 seconds
    DOSSIER: 30 * 1000, // 30 seconds
    DOSSIER_OVERVIEW: 2 * 60 * 1000, // 2 minutes
    DISCUSSION: 2 * 60 * 1000, // 2 minutes
    AGENT_SETTINGS: 5 * 60 * 1000, // 5 minutes - agent settings change infrequently
    DISSATISFACTION_CATEGORIES: 5 * 60 * 1000, // 5 minutes - testimonial data rarely changes
} as const;

const RETRYABLE_4XX_STATUSES = new Set([408, 409, 429]);

function shouldRetryOnError(failureCount: number, error: Error): boolean {
    if (failureCount >= 2) {
        return false;
    }

    if (error instanceof ApiClientError) {
        const { status } = error;

        if (status >= 400 && status < 500) {
            return RETRYABLE_4XX_STATUSES.has(status);
        }
    }

    return true;
}

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: QUERY_STALE_TIMES.DEFAULT,
            retry: shouldRetryOnError,
            retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
        },
    },
    queryCache: new QueryCache({
        onError: (error) => {
            sendErrorReport(error);
        },
    }),
    mutationCache: new MutationCache({
        onError: (error) => {
            sendErrorReport(error);
        },
    }),
});
